import React from 'react';
import { IWireDepositData } from '../../../../../types/order/escrow/IWireDepositData';
import { generateWireDepositTableColumns } from './generateWireDepositTableColumns';
import { Grid, Header2Text } from '../../../../../ui-toolkit';
import { StyledDisbursedContainer } from '../../shared/StyledDisbursedContainer';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { IOrderDetailsData } from '../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';
import { useHasFeatureFlag } from 'selectors/useHasFeatureFlag';

interface IWireDepositsContainerProps {
  order: IOrderDetailsData;
  wireDeposits: IWireDepositData[];
}

export const WireDepositsContainer: React.FC<IWireDepositsContainerProps> = ({ order, wireDeposits }) => {
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const wireDepositColumns: IBootstrapTableColumnProps<any>[] = generateWireDepositTableColumns({ order, isSpruceWithZillowEnabled, isZillowClosingEnabled });
  return (
    <Grid>
      <Header2Text>Wire Deposits</Header2Text>
      <StyledDisbursedContainer
        defaultSorted={[{ dataField: 'updatedAt', order: 'desc' }]}
        columns={wireDepositColumns}
        keyField={'id'}
        data={wireDeposits}
      />
    </Grid>
  );
};
